<template>
  <div>
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
      <md-card >
        <md-card-header class="hide-mobile" data-background-color="newyellow">
          <div style="display: flex;align-items: center;">
            <md-icon class="configicon">archive</md-icon>
            <h4 class="tittle">Versões</h4>
          </div>
        </md-card-header>
        <md-card-content>        
          <ListaArquivos />          
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import ListaArquivos from "../components/Versoes/ListaVersoes";
export default {
  components: {
    ListaArquivos,
  },
  data() {
    return {
      icons: true,
      centered: false,
      grow: false,
      vertical: true
    };
  }, created(){

  }
};
</script>
<style scoped>
.configicon {
  width: 20px;
  margin: 3px;
  margin-right: 19px;
  color: #fff !important;
  font-size: 36px !important;
}
</style>
